import React, { Component } from 'react';
import Slider from 'react-rangeslider';
require(`../assets/${process.env.PAGE}/css/custom-slider.css`);

class CustomSlider extends Component {

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            value: null
        };
    }

    onChange(value) {
        let selectedValue = this.props.productList[value - 1];
        this.props.input.onChange(Number(selectedValue));
        this.setState({ value: Number(value) });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialValue && nextProps.productList) {
            let currentValue = nextProps.productList.indexOf(nextProps.initialValue.toString());
            this.setState({ value: Number(currentValue + 1) });
        }
    }

    render() {

        return (this.props.productList &&
            <div>
                <div className={'form-group'}>
                    <label className="control-label rangeslider-label">{this.props.label}</label>
                    <div className="slider-wrapper">
                        <Slider
                            {...this.props.input}
                            orientation='horizontal'
                            min={1}
                            max={this.props.productList.length}
                            step={1}
                            onChange={this.onChange}
                            value={this.state.value}
                        />
                        <div className="slider-tooltip" style={{ left: `${(this.state.value - 1) / (this.props.productList.length - 1) * 100}%` }}>
                            <span>{this.props.selectedAmount}</span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-left no-gutters amounts-available">
                        <b>{this.props.minAmountAvailable}</b>
                    </div>
                    <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6 text-center">
                    </div>
                    <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 text-right no-gutters amounts-available">
                        <b>{this.props.maxAmountAvailable}</b>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomSlider;



/** WEBPACK FOOTER **
 ** ./src/components/CustomSlider.js
 **/